/*
 * @Description: Do not edit
 * @Author: Do not edit
 * @Date: 2019-10-31 22:40:34
 * @LastEditTime: 2019-10-31 23:23:33
 * @LastEditors: he.jianbo
 */
/**
 * 产品管理 微博 添加微博账号
 * author: Qian.qianchen 2018-11-14
 */
"use strict";
angular.module("weiboAccountBindModule", [])
    .controller('weiboAccountBindCtrl', ['$scope', '$modalInstance', '$validation', 'trsHttpService','options', function($scope, $modalInstance, $validation, trsHttpService,options) {
        initStatus();

        function initStatus() {
            console.log("传入：",options);
            $scope.data = {
                currUser: {
                    sinaLoginUserName: '',
                    sinaUserLoginPwd: '',
                    objectId: options.objectId,
                }
            }
        }
        /**
         * [checkProperty description] 是否检查稿件属性
         * @return {[type]} [description]
         */
        $scope.checkProperty = function() {
            $scope.data.currUser.checkFgdAttribute = $scope.data.currUser.checkFgdAttribute == '0' ? '1' : '0';
        };
        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        /**
         * [confirm description] 表单信息提交-确认
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            var params = {
                serviceid: "wcm61_scmaccount",
                methodname: "bindAccountForVideo",
                sinaLoginUserName: $scope.data.currUser.sinaLoginUserName,
                sinaUserLoginPwd: $scope.data.currUser.sinaUserLoginPwd,
                objectId: $scope.data.currUser.objectId
            }
            $scope.accountForm.$pending = {};
            $validation.validate($scope.accountForm).success(function() {
                LazyLoad.js(["./lib/js-base64/base64.js"], function() {
                    params.sinaUserLoginPwd = Base64.encode(angular.copy($scope.data.currUser.sinaUserLoginPwd));
                    $scope.loadingPromise = trsHttpService.httpServer('/wcm/rbcenter.do', params, 'post', true).then(function(data) {
                        $modalInstance.close("success");
                    }, function(data) {
                        $modalInstance.close();
                    });
                });
            });
        };
    }]);